module.exports = __webpack_public_path__ + "static/media/chicken2.76f9f309.jpg";